import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { GameProvider } from './contexts/GameContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import GameRoomPage from './pages/GameRoomPage';
import ProfilePage from './pages/ProfilePage';
import LeaderboardPage from './pages/LeaderboardPage';
import DailyChallengePage from './pages/DailyChallengePage';
import Navbar from './components/Navbar';
import { ToastHost } from './components/Toast';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';
import './App.css';
import { initGA } from './analytics';

const basename = process.env.PUBLIC_URL || '';

// Track page views
function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Never send query strings or token paths to analytics: the Google login
    // redirect carries the session token in ?token=.
    const page = location.pathname.replace(/^\/(reset-password|verify-email)\/[^/]+/, '/$1/:token');
    window.gtag('event', 'page_view', {
      page_path: page,
      page_location: window.location.origin + page,
    });
  }, [location]);
  
  return null;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  return (
    <Router basename={basename}>
      <AuthProvider>
        <GameProvider>
          <div className="app">
            <Navbar />
            <ToastHost />
            <PageTracker />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/daily" element={<DailyChallengePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/game/:roomId" element={<GameRoomPage />} />
                <Route path="/profile/:username" element={<ProfilePage />} />
                <Route path="/leaderboard" element={<LeaderboardPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/verify-email/:token" element={<VerifyEmail />} />
              </Routes>
            </main>
          </div>
        </GameProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
